

(function ($) {
    $(function () {

        if ($('.template--my-profile').length) {
            $('.js-edit').on('click', function (e) {
                $('.js-account-form').removeClass('disabled');
                $(this).hide();
            });


            if ($('.js-general-success-modal').length) {
                if (window.profile_message && $('#error__modal').length == 0) {
                    $('.js-general-success-modal-message').html(window.profile_message);
                    Fancybox.show([{
                        src: "#general__success_modal",
                        type: "inline",
                        closeButton: false,
                        hideScrollbar: true
                    }]);
                }

            }

            if ($('.mepr_update_account_table').length) {
                $('.mepr-submit').addClass('button button--primary button--small').val('Save changes')
            }




            if ($('.js-account-settings').length) {
                $('.mepr-account-cancel').text('Cancel subscription')
                $('.mepr-account-cancel').prepend('<p>If you no longer wish to be a premium subscriber cancel your subscription below:</p>')
            }



            $('.js-delete-account-open').on('click', function (e) {
                e.preventDefault();

                Fancybox.show([{
                    src: "#general__info_modal",
                    type: "inline",
                    closeButton: false,
                    hideScrollbar: true
                }]);

            })

            $(document).on('click', '.js-delete-account', function (e) {
                e.preventDefault();
                var user_id = $(this).data('user-id');
                var nonce = $(this).data('nonce');
                $.ajax({
                    url: localize.ajaxurl,
                    data: {
                        'action': 'delete_account',
                        'user_id': user_id,
                        'nonce': nonce
                    },
                    success: function (response) {
                        if (response == "Account Deleted") {
                            // Logout and redirect to homepage
                            $.get(localize.logouturl, function () {
                                window.location.href = localize.homeurl
                            });
                        }
                    },
                    error: function () {
                        alert("There was an error deleting your account. Please try again later.");
                    }
                });

            });


            $('.js-copy-gift-url').on('click', function (e) {

            })






        }

    });
})(jQuery);